var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.2041H15M9 14.2041H15M13.0004 3.20497C12.9048 3.2041 12.7974 3.2041 12.6747 3.2041H8.2002C7.08009 3.2041 6.51962 3.2041 6.0918 3.42209C5.71547 3.61384 5.40973 3.91957 5.21799 4.2959C5 4.72372 5 5.28419 5 6.4043V18.0043C5 19.1244 5 19.6842 5.21799 20.112C5.40973 20.4883 5.71547 20.7946 6.0918 20.9863C6.51921 21.2041 7.079 21.2041 8.19694 21.2041L15.8031 21.2041C16.921 21.2041 17.48 21.2041 17.9074 20.9863C18.2837 20.7946 18.5905 20.4883 18.7822 20.112C19 19.6846 19 19.1256 19 18.0077V9.52979C19 9.40712 18.9999 9.29964 18.999 9.2041M13.0004 3.20497C13.2858 3.20758 13.4657 3.21817 13.6382 3.25957C13.8423 3.30857 14.0379 3.38937 14.2168 3.49902C14.4186 3.62267 14.5918 3.79591 14.9375 4.1416L18.063 7.26708C18.4089 7.61299 18.5809 7.78546 18.7046 7.9873C18.8142 8.16624 18.8953 8.36136 18.9443 8.56543C18.9857 8.73789 18.9964 8.91865 18.999 9.2041M13.0004 3.20497L13 6.00431C13 7.12442 13 7.68425 13.218 8.11208C13.4097 8.4884 13.7155 8.79458 14.0918 8.98633C14.5192 9.2041 15.079 9.2041 16.1969 9.2041H18.999",
    stroke: "#636980",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/Documents.a2e01397b3d1530a036fdbf6f503fccc.svg";
export { ForwardRef as ReactComponent };